import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ReportForm } from '../../components/ReportForm/ReportForm';
import { IReportSpacePopupParams, useReportSpacePresenter } from './ReportSpacePopup.presenter';

export const ReportSpacePopup: FC<ICommonPopupsProps<IReportSpacePopupParams>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useReportSpacePresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={t('common_report')}
        isOpened
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <ReportForm
          title={t('content_moderation_community')}
          onSubmit={presenter.onSubmit}
        />
      </Popup>
    );
  }
);
